const Isotope = require('isotope-layout');
const accordion = document.querySelector('.accordion');
const filterBtns = document.querySelectorAll('.filterBtn');
const filtersElem = document.querySelector('.filters-button-group');
const accordionItems = document.querySelectorAll('.accordionItem');
const testimonials = document.querySelectorAll('.testimonials');
const filterMessage = document.querySelector('#filterMessage');

if (accordion) {

    window.addEventListener('load', () => {
        let iso = new Isotope(accordion, {
            // options
            itemSelector: '.accordionItem',
            layoutMode: 'fitRows'
        });

		if (filtersElem) {
			// bind filter button click
			filtersElem.addEventListener('click', ( e ) => {
				let filterValue = e.target.getAttribute('data-filter');

				iso.arrange({
					filter: filterValue
				});
			});
		}

		accordionItems.forEach( (item) => {
			item.addEventListener('click', () => {
				setTimeout( () => {
					iso.arrange();
				}, 50);
			})
		})


		filterBtns.forEach( (item) => {
			item.addEventListener('click', () => {

				filterBtns.forEach( (item) => {
					item.classList.remove('is-active');
				})

				item.classList.add('is-active');

				accordionItems.forEach( (item) => {
					const details = item.querySelector('details');

					details.removeAttribute('open');
				})

				iso.on('arrangeComplete', (filteredItems) => {
					if (filteredItems.length < 1) {
						filterMessage.classList.remove('hidden');
					} else {
						filterMessage.classList.add('hidden');
					}
				});
			});
		})
    });
}

if (testimonials) {

	testimonials.forEach( (item) => {
		let isoTestimonials = new Isotope(item, {
			// options
			itemSelector: '.testimonialItem',
			layoutMode: 'fitRows'
		});

		if (filtersElem) {
			// bind filter button click
			filtersElem.addEventListener('click', ( e ) => {
				let filterValue = e.target.getAttribute('data-filter');

				isoTestimonials.arrange({
					filter: filterValue
				});
			});
		}

		filterBtns.forEach( (item) => {
			item.addEventListener('click', () => {

				filterBtns.forEach( (item) => {
					item.classList.remove('is-active');
				})

				item.classList.add('is-active');

				isoTestimonials.on('arrangeComplete', (filteredItems) => {
					filterMessage.classList.add('hidden');

					if (filteredItems.length < 1) {
						filterMessage.classList.remove('hidden');
					} else {
						filterMessage.classList.add('hidden');
					}
				});
			});
		})
	})
}
